import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "@/i18n/LangContext";

export default function About() {
  const { t } = useLang();
  const CHAPTERS = t("about.chapters");
  return (
    <section id="about" data-testid="about-section" className="px-5 py-24 sm:px-8 lg:py-36">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
          <div className="lg:sticky lg:top-32 lg:self-start">
            <Reveal>
              <Eyebrow>{t("about.eyebrow")}</Eyebrow>
              <h2 className="font-display mt-6 text-3xl font-light leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                {t("about.h1")}
                <br />
                <span className="italic" style={{ color: "var(--accent-gold)" }}>{t("about.h2")}</span>
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                {t("about.quote")}
              </p>
              <div className="mt-10 hidden overflow-hidden rounded-2xl border lg:block" style={{ borderColor: "var(--border-delicate)" }}>
                <img
                  src="/images/mahima.webp"
                  alt={t("about.imgAlt")}
                  className="aspect-[4/3] w-full object-cover object-[center_20%] transition-transform duration-700 hover:scale-[1.03]"
                />
              </div>
            </Reveal>
          </div>

          <div className="space-y-2">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <article
                  data-testid={`about-manifesto-chapter-${i + 1}`}
                  className="group border-t py-10 first:border-t-0 first:pt-0 lg:py-12"
                  style={{ borderColor: "var(--border-delicate)" }}
                >
                  <div className="flex items-baseline gap-6">
                    <span className="font-mono-alt text-sm" style={{ color: "var(--accent-gold)" }}>
                      {c.n}
                    </span>
                    <div>
                      <h3 className="font-display text-2xl font-normal leading-snug sm:text-3xl">
                        {c.title}
                      </h3>
                      <p className="mt-4 max-w-xl text-sm leading-relaxed sm:text-base" style={{ color: "var(--text-secondary)" }}>
                        {c.body}
                      </p>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
